// db.ts
import Dexie, { Table } from 'dexie';

export interface Replenishment {
    id?: number;
    settlement_time: Date;
    terminal_id: string;
    settlement_number: number;
    username: string;
    type: string;
    receipt: any;
    printed?: boolean;
}
export interface ZTrail {
    id?: number;
    trail: string;
    date_created: Date;
}
export interface EngageLog {
    id?: number;
    message: string;
    metadata?: any;
    type: 'AppLog_Info' | 'AppLog_Warning' | 'AppLog_Error'
    date_created: string;
}

export class AppDB extends Dexie {
    replenishments!: Table<Replenishment, number>;
    logs!: Table<ZTrail, number>;
    signalRLogs!: Table<EngageLog, number>;

    constructor() {
        super('ngdexieliveQuery');
        this.version(3).stores({
            replenishments: '++id, settlement_time, terminal_id, settlement_number, username, previous_settlement, type, receipt, printed',
            logs: '++id, trail, date_created',
            signalRLogs: '++id, message, metadata, type, date_created',
        });
    }
}

export const db = new AppDB();
export const getLogs = async () => {
    return ((await db.signalRLogs.toArray()).map((item) => {
        return {
            ...item,
            date_created: new Date(item.date_created)
        }
    }))
}
(<any>window).getLogs = getLogs;